import React from 'react';
import { t } from 'ttag';
import SocialInstagram from 'js/reusable-components/icons/social/SocialInstagram';
import SocialFacebook from 'js/reusable-components/icons/social/SocialFacebook';
import SocialYoutube from 'js/reusable-components/icons/social/SocialYoutube';
import SocialTiktok from 'js/reusable-components/icons/social/SocialTiktok';
import SocialSnapchat from 'js/reusable-components/icons/social/SocialSnapchat';

function Social({
  iconsToShow = ['YouTube', 'Instagram', 'Facebook', 'TikTok']
}) {
  const allIcons = {
    YouTube: {
      name: 'YouTube',
      svg: <SocialYoutube />,
      link:
        window?.headerData?.links?.youtube ||
        'https://www.youtube.com/user/wwwunisportdk'
    },
    Facebook: {
      name: 'Facebook',
      svg: <SocialFacebook />,
      link:
        window?.headerData?.links?.facebook ||
        'https://www.facebook.com/unisportstore'
    },
    Instagram: {
      name: 'Instagram',
      svg: <SocialInstagram />,
      link:
        window?.headerData?.links?.instagram ||
        'https://www.instagram.com/unisportstore/'
    },
    TikTok: {
      name: 'TikTok',
      svg: <SocialTiktok />,
      link:
        window?.headerData?.links?.tiktok ||
        'https://www.tiktok.com/@unisportstore'
    },
    SnapChat: {
      name: 'SnapChat',
      svg: <SocialSnapchat />,
      link:
        window?.headerData?.links?.snapchat ||
        'https://www.snapchat.com/add/unisportlife'
    }
  };

  return (
    <div className="flex flex-wrap justify-end gap-4 p-4">
      {iconsToShow?.map(
        iconName =>
          (
            <a
              className="flex h-10 w-10 items-center justify-center rounded bg-black fill-white"
              key={
                allIcons?.[iconName]?.name ||
                allIcons?.[iconName]?.link ||
                'Social Media'
              }
              href={allIcons?.[iconName]?.link || '#'}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={
                allIcons?.[iconName]?.name || t`Check out our social accounts`
              }
            >
              {allIcons?.[iconName]?.svg}
            </a>
          ) || ''
      )}
    </div>
  );
}

export default Social;
